// utils/date-utils.ts
export const getLocalISOString = (date: Date = new Date()): string => {
    const offsetMs = date.getTimezoneOffset() * 60 * 1000 // getTimezoneOffset trả về phút, đảo dấu
    const localTime = new Date(date.getTime() - offsetMs)
    const offsetMinutes = -date.getTimezoneOffset()
    const sign = offsetMinutes >= 0 ? "+" : "-"
    const absOffset = Math.abs(offsetMinutes)
    const hh = String(Math.floor(absOffset / 60)).padStart(2, "0")
    const mm = String(absOffset % 60).padStart(2, "0")
    return localTime.toISOString().replace("Z", `${sign}${hh}:${mm}`)
    // VD: "2025-04-07T17:00:00+07:00" thay vì "2025-04-07T10:00:00.000Z"
  }